// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/v1/options.proto (package gportal.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, MethodOptions, proto3 } from "@bufbuild/protobuf";
import { DebugInfo } from "../../google/rpc/error_details_pb.js";

/**
 * @generated from enum gportal.v1.Role
 */
export enum Role {
  /**
   * @generated from enum value: ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROLE_SUPPORT = 1;
   */
  SUPPORT = 1,

  /**
   * @generated from enum value: ROLE_ADMIN = 2;
   */
  ADMIN = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(Role)
proto3.util.setEnumType(Role, "gportal.v1.Role", [
  { no: 0, name: "ROLE_UNSPECIFIED" },
  { no: 1, name: "ROLE_SUPPORT" },
  { no: 2, name: "ROLE_ADMIN" },
]);

/**
 * @generated from message gportal.v1.GPortalSettings
 */
export class GPortalSettings extends Message<GPortalSettings> {
  /**
   * @generated from field: bool public = 1;
   */
  public = false;

  /**
   * @generated from field: optional gportal.v1.Role required_role = 2;
   */
  requiredRole?: Role;

  /**
   * @generated from field: bool allow_static_token = 3;
   */
  allowStaticToken = false;

  constructor(data?: PartialMessage<GPortalSettings>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.v1.GPortalSettings";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "public", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "required_role", kind: "enum", T: proto3.getEnumType(Role), opt: true },
    { no: 3, name: "allow_static_token", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GPortalSettings {
    return new GPortalSettings().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GPortalSettings {
    return new GPortalSettings().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GPortalSettings {
    return new GPortalSettings().fromJsonString(jsonString, options);
  }

  static equals(a: GPortalSettings | PlainMessage<GPortalSettings> | undefined, b: GPortalSettings | PlainMessage<GPortalSettings> | undefined): boolean {
    return proto3.util.equals(GPortalSettings, a, b);
  }
}

/**
 * We need to somehow use the google/rpc/error_details.proto to stop the proto lint state of the pipeline complaining
 * about an unused import. The import is needed, because otherwise the proto compiler will not provide the necessary
 * interfaces in the JS and TS files generated for the website client.
 *
 * @generated from message gportal.v1.Dummy
 */
export class Dummy extends Message<Dummy> {
  /**
   * @generated from field: google.rpc.DebugInfo debug_info = 1;
   */
  debugInfo?: DebugInfo;

  constructor(data?: PartialMessage<Dummy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.v1.Dummy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "debug_info", kind: "message", T: DebugInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Dummy {
    return new Dummy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Dummy {
    return new Dummy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Dummy {
    return new Dummy().fromJsonString(jsonString, options);
  }

  static equals(a: Dummy | PlainMessage<Dummy> | undefined, b: Dummy | PlainMessage<Dummy> | undefined): boolean {
    return proto3.util.equals(Dummy, a, b);
  }
}

/**
 * @generated from extension: gportal.v1.GPortalSettings api = 1100;
 */
export const api = proto3.makeExtension<MethodOptions, GPortalSettings>(
  "gportal.v1.api", 
  MethodOptions, 
  () => ({ no: 1100, kind: "message", T: GPortalSettings }),
);

